import { lazy, ComponentType } from 'react';

/**
 * A wrapper around React.lazy() that automatically reloads the page if a chunk fails to load.
 * This handles the "ChunkLoadError" often seen after a new deployment when users have an old index.html cached.
 */
export const lazyRetry = (componentImport: () => Promise<{ default: ComponentType<any> }>, name: string = 'unknown') => {
    return lazy(async () => {
        const pageHasAlreadyBeenForceRefreshed = JSON.parse(
            window.sessionStorage.getItem('page-has-been-force-refreshed') || 'false'
        );

        try {
            const component = await componentImport();
            window.sessionStorage.setItem('page-has-been-force-refreshed', 'false');
            return component;
        } catch (error: any) {
            if (!pageHasAlreadyBeenForceRefreshed) {
                // Assuming that the user is not on the latest version of the application.
                // Let's refresh the page immediately.
                window.sessionStorage.setItem('page-has-been-force-refreshed', 'true');
                window.location.reload();
                // Return a promise that never resolves to allow reload to happen without showing error boundary
                return new Promise(() => { });
            }

            // The page has already been reloaded
            // Assuming that user is already using the latest version of the application.
            // Let's let the application crash and raise the error.
            throw error;
        }
    });
};
